import React from 'react';
import { ConfigContainer } from '../common/style/Common.style';
import ComoConfigCreateForm from './ComoConfigCreateForm/ComoConfigCreateForm';
import ComoConfigUpdateForm from './ComoConfigUpdateForm/ComoConfigUpdateForm';

import {
    PanelTitle,
    PanelText,
    ConfigWrapper,
    SuccessMessage,
} from '../SplioLoyaltyIntegration/SplioLoyaltyIntegration.style';
import Modal from '@/components/atoms/Modal';
import { ActionBar } from '@/components/atoms/ActionBar';
import { Button } from '@/components/atoms/Button';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import useCreateComoConfig from './ComoConfigCreateForm/useCreateComoConfig';
import useUpdateComoConfig from './ComoConfigUpdateForm/useUpdateComoConfig';
import useComoLoyaltyIntegrationVM from './ComoLoyaltyIntegrationVM';
import Loader from '@/components/atoms/Loader';
const ComoLoyaltyIntegration = () => {
    const { restaurantId } = useParams<{ restaurantId: string; brandId: string }>();
    const {
        hasComoConfig,
        loyaltyConfig,
        loyaltyPrograms,
        isLoading,
        isDeleting,
        isModalOpen,
        setIsModalOpen,
        deleteConfig,
        isLoadingLoyaltyPrograms,
    } = useComoLoyaltyIntegrationVM();
    const { onSubmit, control, handleSubmit, isCreating, isDirty: isCreateDirty, createError } = useCreateComoConfig();
    const {
        onSubmit: onUpdateSubmit,
        control: updateControl,
        handleSubmit: updateHandleSubmit,
        isUpdating,
        isDirty: isUpdateDirty,
        isValid: isUpdateValid,
        isUpdateSuccess,
    } = useUpdateComoConfig();

    const handleSave = () => {
        if (hasComoConfig) {
            updateHandleSubmit(onUpdateSubmit)();
        } else {
            handleSubmit(onSubmit)();
        }
    };
    return (
        <ConfigWrapper>
            <ConfigContainer>
                <div>
                    <PanelTitle text="como.title" />
                    <PanelText text="como.description" />
                </div>
                <div>
                    {isLoading ? (
                        <Loader withContainer />
                    ) : !hasComoConfig ? (
                        <ComoConfigCreateForm
                            control={control}
                            canChangeProvider={!loyaltyConfig?.provider || loyaltyConfig?.provider === 'como'}
                            createError={!!createError}
                        />
                    ) : isLoadingLoyaltyPrograms && loyaltyPrograms ? (
                        <div>Loading...</div>
                    ) : (
                        <ComoConfigUpdateForm
                            control={updateControl}
                            loyaltyPrograms={loyaltyPrograms}
                            loyaltyConfig={loyaltyConfig}
                        />
                    )}
                </div>
            </ConfigContainer>
            <Modal
                isOpen={isModalOpen}
                title="como.deleteModal.title"
                onHide={() => setIsModalOpen(false)}
                width={500}
                buttons={[
                    <Button
                        buttonType="red"
                        onClick={() => {
                            deleteConfig({ restaurantId: Number(restaurantId) });
                            setIsModalOpen(false);
                        }}
                        isLoading={isDeleting}
                    >
                        <FormattedMessage id="button.delete" />
                    </Button>,
                ]}
            >
                <p>
                    <FormattedMessage id="como.deleteModal.text" />
                </p>
            </Modal>
            <ActionBar>
                {isUpdateSuccess && (
                    <SuccessMessage>
                        <FormattedMessage id="como.update.success" />
                    </SuccessMessage>
                )}
                {hasComoConfig && (
                    <Button buttonType="red" onClick={() => setIsModalOpen(true)} isLoading={isDeleting}>
                        <FormattedMessage id="button.delete" />
                    </Button>
                )}

                <Button
                    buttonType="primary"
                    disabled={!((isUpdateDirty && isUpdateValid) || isCreateDirty)}
                    onClick={handleSave}
                    isLoading={isCreating || isUpdating}
                >
                    <FormattedMessage id="button.save" />
                </Button>
            </ActionBar>
        </ConfigWrapper>
    );
};

export default ComoLoyaltyIntegration;
